/** Referral codes are three hyphen-separated groups of three letters, e.g. BAB-BAB-BAB (CVC-CVC-CVC). */
const REFERRAL_CODE_PATTERN = /^[A-Z]{3}-[A-Z]{3}-[A-Z]{3}$/;

/**
 * Formats raw referral-code input the way the mobile app does: upper-cased, non-letters stripped,
 * and a hyphen inserted after every third character (CVC-CVC-CVC), capped at nine letters.
 */
export const formatReferralCode = (value: string): string => {
  const letters = value
    .toUpperCase()
    .replace(/[^A-Z]/g, '')
    .slice(0, 9);

  return letters.replace(/(.{3})(?=.)/g, '$1-');
};

/** A referral code is complete once it matches the full AAA-BBB-CCC shape (nine letters, both hyphens). */
export const isReferralCodeComplete = (value: string): boolean => REFERRAL_CODE_PATTERN.test(value);
